import CTLDate from "application/components/CTLDate";
import CTLSelectCell from "application/components/CTLSelectCell";
import DefaultCell from "application/components/DefaultCell";
import CTLDay from "../CTLDay";
import formControl from "globals/form-control";
import { useEffect, useState } from "react";

const getUpdateColumns = (formData) => {
  const [isEnable, setIsEnable] = useState(false);

  useEffect(() => {
    if (formData.servingApp == "transfer") {
      setIsEnable(true);
    }else{
       setIsEnable(false);
    }
  }, [formData]);

  const onChangeServingApp = (event, formik) => {
    if (event.target.value == "transfer") {
      setIsEnable(true);
    } else {
      setIsEnable(false);
    }
  };

  return [
    {
      Header: "Day",
      accessor: "day",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      disabled: true,
      Cell: ({ value }) => <CTLDay value={value} />,
      width: 4,
    },
    {
      Header: "Created On",
      accessor: "createdOn",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <CTLDate value={value} />,
      width: 4,
    },
    {
      Header: "From Time",
      accessor: "fromTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "time",
      validation: formControl.string().required("Required"),
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 4,
    },
    {
      Header: "To Time",
      accessor: "toTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "time",
      validation: formControl.string().required("Required"),
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 4,
    },
    {
      Header: "Serving App (transfer type)",
      accessor: "servingApp",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 4,
      controlType: "select",
      onChange: onChangeServingApp,
      validation: formControl.string().required("Required"),
      options: {
        keyField: "id",
        keyDescription: "description",
        values: [
          { id: "hangup", description: "Hangup" },
          { id: "transfer", description: "Transfer" },
          { id: "extensionMode", description: "Extension Mode" },
        ],
        url: "",
      },
    },
    {
      Header: "Serving Data (transfer number)",
      accessor: "servingData",
      displayInList: true,
      allowInForm: isEnable,
      allowFilter: false,
      dataType: "string",
      validation: formControl.string().digitsOnly().required("Required"),
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 4,
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
    },
  ];
};

export { getUpdateColumns };
